var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ico",class:_vm.getClass(),attrs:{"data-label":_vm.label}},[_c('i',{attrs:{"data-icoTarget":_vm.valueIco,"data-value":_vm.valueText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }